import type { BoxProps } from '../Box';
import { Box } from '../Box';
import { styled } from '@withjoy/joykit/theme';

export interface FlexProps extends BoxProps {}

const Flex = styled(Box).attrs<FlexProps>(props => ({ display: props.display || 'flex' }))``;

if (__DEV__) {
  Flex.displayName = 'Flex';
}

export { Flex };
